import React from 'react';
import { Div } from '@dnb/eufemia';
import classnames from 'classnames';
import styles from './Header.module.scss';

interface Props {
  narrow: boolean;
  children: React.ReactNode;
}

const Header = ({ children, narrow }: Props) => {
  const classname = classnames(styles.header, {
    [styles.narrow]: narrow,
  });
  return (
    <Div data-testid="header" top="large x-small">
      <Div
        data-testid={`header-${narrow ? 'narrow' : 'wide'}`}
        className={classname}
      >
        {children}
      </Div>
    </Div>
  );
};

export default Header;
